import { parseForSummary } from "@vingle/wtf-sdk/helpers/postContentParser";

export default function getPreviewContent(
  content: Vingle.Discover.IDiscoverContent,
) {
  // tslint:disable-next-line:no-small-switch
  switch (content.preview.type) {
    case "card": {
      return parseForSummary(content.preview.content).texts.join(" ");
    }
    default: {
      return "";
    }
  }
}
